import { useCallback, useState } from "react";

export type MyBoolean = {
  value: boolean;
  setTrue: () => void;
  setFalse: () => void;
  toggle: () => void;
  setValue: (v: boolean) => void;
};

export function useBoolean(initial = false): MyBoolean {
  const [value, setValue] = useState<boolean>(initial);
  const setTrue = useCallback(() => setValue(true), []);
  const setFalse = useCallback(() => setValue(false), []);
  const toggle = useCallback(() => setValue((v) => !v), []);
  return { value, setTrue, setFalse, toggle, setValue };
}
